module.exports = __webpack_public_path__ + "static/crossed-arm-1720a983c445554d41b97c4db24539fe.png";